/*
 * SMParts — Zuletzt angesehene Produkte
 *
 * Zwei Aufgaben in einer Datei, weil sie zusammengehoeren:
 *
 *   1. Auf einer Produktseite den Artikel merken.
 *   2. Auf der Startseite die gemerkten Artikel anzeigen.
 *
 * Die Liste liegt im localStorage des Besuchers. Sie verlaesst das Geraet
 * nicht und wird nirgends gespeichert — es ist kein Nutzerprofil, nur
 * eine Bequemlichkeit.
 */
(function () {
  var SCHLUESSEL = 'smp:gesehen';
  var MAX = 20;

  /* --------------------------------------------------------- Speicher */

  function lesen() {
    try {
      var roh = window.localStorage.getItem(SCHLUESSEL);
      var liste = roh ? JSON.parse(roh) : [];
      return Array.isArray(liste) ? liste : [];
    } catch (e) {
      /* Privater Modus oder gesperrter Speicher: dann gibt es die
         Funktion eben nicht. Kein Grund, die Seite scheitern zu lassen. */
      return [];
    }
  }

  function schreiben(liste) {
    try {
      window.localStorage.setItem(SCHLUESSEL, JSON.stringify(liste.slice(0, MAX)));
    } catch (e) {
      /* siehe oben */
    }
  }

  function merken(handle) {
    if (!handle) return;
    var liste = lesen().filter(function (h) {
      return h !== handle;
    });
    liste.unshift(handle);
    schreiben(liste);
  }

  /* ------------------------------------------------- Auf der Produktseite */

  var quelle = document.querySelector('[data-smp-gesehen-handle]');
  if (quelle) merken(quelle.getAttribute('data-smp-gesehen-handle'));

  /* -------------------------------------------------------- Geldbetrag */

  /*
   * Shopify liefert ueber /products/<handle>.js nur Cent-Betraege. Das
   * Format des Shops kommt aus Liquid, damit hier nicht "80.00 EUR"
   * steht, wo im Rest des Shops "€80,00" steht.
   */
  function geld(cent, format) {
    var betrag = (cent / 100).toFixed(2);
    var ganz = betrag.split('.')[0];
    var rest = betrag.split('.')[1];
    var mitPunkt = ganz.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var mitKomma = ganz.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return (format || '€{{amount_with_comma_separator}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, mitPunkt + ',' + rest)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, mitPunkt)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, mitKomma)
      .replace(/\{\{\s*amount\s*\}\}/g, mitKomma + '.' + rest);
  }

  function bildUrl(url, breite) {
    if (!url) return '';
    var voll = url.indexOf('//') === 0 ? 'https:' + url : url;
    return voll.replace(/(\.[a-z]+)(\?|$)/i, '_' + breite + 'x$1$2');
  }

  /* ---------------------------------------------------------- Anzeige */

  class SMPGesehen extends HTMLElement {
    connectedCallback() {
      /* connectedCallback laeuft beim Verschieben im DOM erneut — im
         Theme-Editor bei jedem Umsortieren. */
      if (this.bereit) return;
      this.bereit = true;

      this.spur = this.querySelector('.smp-ges__spur');
      if (!this.spur) return;

      /* Zwei Knoepfe: oben (Handy) und unter der Reihe (Rechner). */
      this.querySelectorAll('.smp-ges__loeschen').forEach((loeschen) => {
        loeschen.addEventListener('click', () => {
          schreiben([]);
          this.hidden = true;
        });
      });

      this.aufbauen();
    }

    aufbauen() {
      var anzahl = parseInt(this.dataset.anzahl, 10) || 6;

      /*
       * Die eigene Produktseite ausnehmen: dort ist es sinnlos, das
       * Produkt zu zeigen, das gerade offen ist.
       */
      var eigen = document.querySelector('[data-smp-gesehen-handle]');
      var eigenerHandle = eigen ? eigen.getAttribute('data-smp-gesehen-handle') : null;

      /*
       * Dazu die in den Theme-Einstellungen ausgeblendeten Produkte —
       * Versandschutz und aehnliche Nicht-Teile gehoeren nicht in eine
       * Produktliste. Die Liste steht am Abschnitt, damit das Skript
       * sie nicht kennen muss.
       */
      var verborgen = (this.getAttribute('data-smp-verborgen') || '')
        .split(',')
        .map(function (h) { return h.trim().toLowerCase(); })
        .filter(Boolean);

      var handles = lesen()
        .filter(function (h) {
          return h !== eigenerHandle && verborgen.indexOf(h) === -1;
        })
        .slice(0, anzahl);

      if (!handles.length) return;

      Promise.all(
        handles.map(function (h) {
          return fetch(window.Shopify.routes.root + 'products/' + h + '.js')
            .then(function (a) {
              return a.ok ? a.json() : null;
            })
            .catch(function () {
              /* Produkt geloescht oder offline: still ueberspringen. */
              return null;
            });
        })
      ).then((produkte) => {
        var gute = produkte.filter(Boolean);
        if (!gute.length) return;

        gute.forEach((p) => this.spur.appendChild(this.karte(p)));
        this.hidden = false;
      });
    }

    karte(p) {
      var format = this.dataset.geldformat;
      var imAngebot = p.compare_at_price && p.compare_at_price > p.price;

      var li = document.createElement('li');
      li.className = 'smp-reihe__item';

      var a = document.createElement('a');
      a.className = 'smp-karte';
      a.href = window.Shopify.routes.root.replace(/\/$/, '') + p.url;

      var bild = document.createElement('div');
      bild.className = 'smp-karte__bild';
      if (p.featured_image) {
        var img = document.createElement('img');
        img.src = bildUrl(p.featured_image, 400);
        img.alt = '';
        img.loading = 'lazy';
        img.width = 400;
        img.height = 400;
        bild.appendChild(img);
      }
      if (!p.available) {
        bild.appendChild(this.marke('Ausverkauft', 'smp-karte__badge--aus'));
      } else if (imAngebot) {
        bild.appendChild(this.marke(this.dataset.markeSale || 'Sale'));
      }
      a.appendChild(bild);

      var titel = document.createElement('p');
      titel.className = 'smp-karte__titel';
      titel.textContent = p.title;
      a.appendChild(titel);

      var preis = document.createElement('p');
      preis.className = 'smp-karte__preis';
      var jetzt = document.createElement('span');
      jetzt.className = 'smp-karte__jetzt';
      jetzt.textContent = geld(p.price, format);
      preis.appendChild(jetzt);
      if (imAngebot) {
        var alt = document.createElement('span');
        alt.className = 'smp-karte__alt';
        alt.textContent = geld(p.compare_at_price, format);
        preis.appendChild(alt);
      }
      a.appendChild(preis);

      var knopf = document.createElement('span');
      knopf.className = 'smp-karte__knopf';
      knopf.textContent = this.dataset.knopf || 'Ansehen';
      a.appendChild(knopf);

      li.appendChild(a);
      return li;
    }

    marke(text, extra) {
      var s = document.createElement('span');
      s.className = 'smp-karte__badge' + (extra ? ' ' + extra : '');
      s.textContent = text;
      return s;
    }
  }

  if (!customElements.get('smp-gesehen')) {
    customElements.define('smp-gesehen', SMPGesehen);
  }
})();
